// extracted by mini-css-extract-plugin
export default {"wrapper":"Banner_wrapper__PvzfI","bannerSection":"Banner_bannerSection__QDcFW"};